<template>
  <div class="number-tile">
    <div class="tile-header">
      <h2 class="tile-title">{{ title }}</h2>
    </div>
    
    <div class="tile-content">
      <div v-if="loading" class="loading-spinner">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      
      <div v-else class="tile-value">
        <h1 :style="{ fontSize: fontSizeForLength(displayValue) }">
          {{ displayValue }}
        </h1>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '../../utils';

export default {
  name: 'NumberTile',
  props: ['title', 'value', 'type', 'loading'],
  data: () => ({
    formatCurrency: Utils.formatCurrency,
  }),
  computed: {
    displayValue() {
      if (this.type === 'currency') {
        return this.formatCurrencyNoCents(this.value);
      }
      return this.value;
    },
  },
  methods: {
    formatCurrencyNoCents(num) {
      if (!num) return '$0';
      const absNum = Math.abs(num);
      const formatted = Math.round(absNum).toLocaleString('en-US');
      return num < 0 ? `($${formatted})` : `$${formatted}`;
    },
    fontSizeForLength(value) {
      const strValue = String(value);
      if (strValue.length < 10) {
        return '48px';
      } else if (strValue.length < 14) {
        return '40px';
      }
      return '32px';
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';

$tile-bg-color: #ffffff;
$tile-text-color: #2d3748;
$tile-border-color: #e2e8f0;
$tile-title-color: #718096;
$tile-value-color: #2d3748;

// Force shadows to show
::v-deep .v-card, ::v-deep .v-sheet {
  box-shadow: none !important;
}

.number-tile {
  background-color: $tile-bg-color;
  border-radius: 12px;
  height: 200px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  color: $tile-text-color;
  box-shadow: $shadow-md !important;
  border: 1px solid $tile-border-color;
  transition: transform $transition-normal $easing-smooth, box-shadow $transition-normal $easing-smooth;
  transform: translate3d(0, 0, 0);
  
  &:hover {
    transform: translate3d(0, $transform-lift, 0);
    box-shadow: $shadow-lg !important;
  }

  @media (max-width: $breakpoint-mobile) {
    height: 180px;
    padding: 20px;
  }
}

.tile-header {
  margin-bottom: 16px;
  
  .tile-title {
    font-size: 16px;
    font-weight: 500;
    color: $tile-title-color;
    margin: 0;
    text-align: left;
    line-height: 1.4;
    
    @media (max-width: $breakpoint-mobile) {
      font-size: 14px;
    }
  }
}

.tile-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .tile-value {
    text-align: center;
    width: 100%;
    
    h1 {
      font-weight: 700;
      color: $tile-value-color;
      margin: 0;
      line-height: 1.2;
      word-break: break-word;
    }
  }
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>